<template lang="pug">
section
  div
    | This role is perhaps the most important
    | of all the roles and must be filled
    | by the senior person responsible
    | for recruitment within the company,
    | which can be a company director
    | or an HR manager.
    | They will be ultimately responsible
    | for the licence, overseeing the SMS
    | and ensuring the sponsorship duties
    | are complied with throughout
    | the life of your licence.

  br

  div
    | ✅ Requirements:
    |

  ul
    li
      | there can only be
      |
      b ONE
      |
      | authorising officer;
    li
      | they must be responsible
      | for deciding how many
      | of your staff need to have access
      | to the Sponsorship Management System (SMS)
      | and what level of permission
      | they can have (e.g. Level 1 or Level 2 user);
    li
      | they do not have automatic access to the SMS.
      | If they require access to the system,
      | they will need to be set up
      | as a Level 1 or Level 2 user.

  br

  div
    | ❗
    |
    | If your Authorising Officer
    | is also a Level 1 user
    | and they are
    |
    b NOT a settled person
    |
    | (e.g. someone who is a British national
    | or has a settled status
    | -
    | Indefinite Leave to remain,
    | Permanent residency, Settled status
    | under EU Settlement Scheme, etc.)
    | OR do
    |
    b NOT have valid leave to remain
    |
    | in the UK under the following visa categories:

  ul
    li Representative of an Overseas Business
    li Tier 1 (Graduate Entrepreneur)
    li Tier 1 (Entrepreneur)
    li Tier 1 (Exceptional Talent)
    li Innovator
    li Start Up
    li Global Talent Migrant

  br

  div
    | Then you must appoint
    | a different Level 1 user,
    | because your company must always
    | have a minimum of
    |
    u
      b ONE
    |
    | Level 1 user who is a settled person
    | or has a valid leave to remain in the UK
    | under certain visa categories.
</template>

<script>
export default {
  name: "key_personnel_officer",
};
</script>